import { Container } from "react-bootstrap";
import ExternalLink from "../ExternalLink";

function Referenzkunden() {
  return (
    <Container style={{ padding: "1.5rem" }}>
      <h1>Referenzen</h1>
      <br />

      <ul>
        <li>
          WBS Training AG –{" "}
          <ExternalLink href="https://www.wbstraining.de">
            www.wbstraining.de
          </ExternalLink>
        </li>
        <li>
          BBS-Online Arne Peters –{" "}
          <ExternalLink href="https://www.bbs-online.de">
            www.bbs-online.de
          </ExternalLink>
        </li>
        <li>
          BFW Nürnberg gGmbH –{" "}
          <ExternalLink href="https://www.bfw-nuernberg.de">
            www.bfw-nuernberg.de
          </ExternalLink>
        </li>
        <li>
          PBU CAD-Systeme (heute Var-Industries GmbH) –{" "}
          <ExternalLink href="https://www.varindustries.de">
            www.varindustries.de
          </ExternalLink>
        </li>
      </ul>

      <div className="spacer"></div>
    </Container>
  );
}

export default Referenzkunden;
